/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Mucus from './mucus';
import MucusDetail from './mucus-detail';
import MucusUpdate from './mucus-update';
import MucusDeleteDialog from './mucus-delete-dialog';

const MucusRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Mucus />} />
    <Route path="new" element={<MucusUpdate />} />
    <Route path=":id">
      <Route index element={<MucusDetail />} />
      <Route path="edit" element={<MucusUpdate />} />
      <Route path="delete" element={<MucusDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MucusRoutes;
